import './design-system.scss';
import './components/accordian/accordian.js';
import './components/menu/menu.js';
import './components/form/form.js';
import './components/alamode/aLaMode.js';
import {initBackToTop} from "./components/back-to-top/back-to-top";
import initBehaviourCopytHrefToClipBoardOnClick from "./behaviors/copyHrefToClipboardOnClick";
import * as utils from './js/utils';

// retro compat TODO delete me apres mise à niveau des utilisation dans le contexte global
window.capitalizeFirstLetter = utils.capitalizeFirstLetter;
window.validatePassword = utils.validatePassword;
window.DesignSystem = {
    utils
}
// Composant qui ont une init sur dom ready : TODO passer en revue les composants existants et les basculer
// vers ce pattern
document.addEventListener('DOMContentLoaded', () => {
    initBackToTop();
    initBehaviourCopytHrefToClipBoardOnClick();
});

console.log('DesignSystem loaded' + window.DesignSystem.utils.capitalizeFirstLetter('test'));
import './js/form-validator/checkFields';

